"use strict";
import React from "react";
import classNames from "classnames";
import { Link } from "react-router";
import { Range } from "immutable";
const Paginator = React.createClass({
  currentPage: function() {
    return Math.min(
      ...[
        parseInt(this.props.location.query.page || "1"),
        this.props.numberOfPages
      ]
    );
  },
  startOffset: function() {
    return this.perPage() * this.currentPage();
  },
  perPage: function() {
    return this.props.perPage || 50;
  },
  pageWindow: function() {
    var startPage = this.currentPage();
    var lastPage = this.props.numberOfPages;
    var windowSize = this.props.windowSize || 15;
    if (lastPage <= windowSize) {
      return Range(1, lastPage + 1);
    }
    var start = startPage - Math.floor(windowSize / 2);
    if (start < 1) {
      start = 1;
    }
    var stop = start + windowSize;
    if (stop > lastPage) {
      stop = lastPage + 1;
      start = Math.max(...[1, stop - windowSize]);
    }
    return Range(start, stop);
  },
  render: function() {
    var page = this.currentPage();
    var prevClasses = classNames({ arrow: true, unavailable: page <= 1 });
    var nextClasses = classNames({
      arrow: true,
      unavailable: page === this.props.numberOfPages
    });
    return /* @__PURE__ */ React.createElement("ul", { "data-component": "Paginator", className: "pagination" }, /* @__PURE__ */ React.createElement("li", { className: prevClasses }, /* @__PURE__ */ React.createElement(
      Link,
      {
        to: this.props.location.pathname,
        query: Object.assign({}, this.props.location.query, {
          page: page - 1
        })
      },
      "\xAB"
    )), this.pageWindow().map(this.showPage), /* @__PURE__ */ React.createElement("li", { className: nextClasses }, /* @__PURE__ */ React.createElement(
      Link,
      {
        to: this.props.location.pathname,
        query: Object.assign({}, this.props.location.query, {
          page: page + 1
        })
      },
      "\xBB"
    )));
  },
  showPage: function(page) {
    return /* @__PURE__ */ React.createElement(
      "li",
      {
        className: classNames({ current: this.currentPage() === page }),
        key: "page-link-" + page
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: this.props.location.pathname,
          query: Object.assign({}, this.props.location.query, { page })
        },
        page
      )
    );
  }
});
export default Paginator;
